import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const styles = {
  back: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: '10px',
  },
}

export default function BackButton({ onClick }) {
  const navigate = useNavigate();
  return (
    <Typography
      color="primary"
      sx={styles.back}
      variant="h4"
      onClick={() => onClick(navigate)}
    >
      <ArrowBackIosIcon color="primary" />
      Back
    </Typography>
  );
}

BackButton.defaultProps = {
  onClick: (navigate) => navigate(-1),
};

BackButton.propTypes = {
  onClick: PropTypes.func,
  gutterTop: PropTypes.bool,
};
